// extracted by mini-css-extract-plugin
export var header = "register-module--header--KqpNr";